<template>

    <div class="container">
        <div v-if="errors.length > 0"
             style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px">
            <ul style="padding: revert; margin: revert">
                <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
            </ul>
        </div>
        <div v-if="successes.length > 0"
             style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px">
            <ul style="padding: revert; margin: revert">
                <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
            </ul>
        </div>
    </div>

    <div class="top-stories" dir="ltr">
        <slider :articles="sliderArticles"></slider>
    </div>
    <div class="row-fluid">
        <div class="container">
            <div class="row">

                <template v-for="(article, index) in featuredTopArticles">
                    <div class="col-12" v-if="index === 0">
                        <banner :article="article"></banner>
                    </div>
                    <div class="col-md-4 col-sm-6" v-else>
                        <home-featured-article :article="article"></home-featured-article>
                    </div>
                </template>
                <div v-if="adPartOne != null">
                    <ad-banner
                        :ad-banner="adPartOne"
                        :ad-banners="adBanners"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="home-section">
        <div class="container">
            <div id="content-container" class="full-width">
                <div id="podcast-content">
                    <div>
                        <div class="full-width col-md-8" v-if="podcasts !=null">
                            <div class="columns-box web-view-poll" style="background: none;margin-bottom: 1rem">
                                <div style="background: var(--cdl-gray-100);height: 50px;">
                                    <h2 class="heading" style="background-image: none;"><a>PODCAST</a></h2>
                                </div>
                            </div>
                            <div class="col-md-12 col-sm-12 video-container">
                                <iframe :src="podcasts.link"
                                        id="video-iframe"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>

                    </div>
                </div>
                <div id="main-content" class="flex-col">
                    <div class="full-width col-md-8"
                         :class="{'order-first': podcasts == null}">
                        <home-tab :second-list-categories="secondListCategories"></home-tab>
                    </div>
                    <ad-banner v-if="adPartTwo != null"
                               :ad-banner="adPartTwo"
                               :ad-banners="adBanners"
                    ></ad-banner>

                    <div>
                        <div class="home-news-section">
                            <div class="home-news-top">
                                <h2 class="heading"><a :href="$store.state.hrefPrefix + '/category/news'">{{
                                        $t('news')
                                    }}</a></h2>
                                <div style="display: none" class="Newsletter-input" v-if="$store.state.language.code !== 'tr'">
                                    <span>{{ $t('subscribe_to_our_newsletter') }}</span>
                                    <form :action="$store.state.hrefPrefix + '/subscribe'" method="post"
                                          @submit.prevent="">
                                        <input type="hidden" name="_token" :value="csrf">
                                        <div class="Newsletter-input">
                                            <input type="text" :placeholder=" $t('your_email_address')" name="email"/>
                                            <button class="g-recaptcha"
                                                    data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                    data-callback="submitSubscribe"> {{ $t('cap_subscribe') }}
                                            </button>
                                            <button style="display: none" type="submit" ref="subscribeFormButton">
                                                {{ $t('cap_subscribe') }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row">
                                <middle-article v-for="article in middleArticles" :article="article"></middle-article>
                            </div>
                            <div class="view-more">
                            <span><a :href="$store.state.hrefPrefix + '/category/news'"> {{
                                    $t('view_more')
                                }}  </a></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="side-content" class="flex-col">
                    <div class="full-width"  v-if="$store.state.language.code !== 'ar'">
                        <div class="columns-box web-view-poll" v-if="poll != null">
                            <h2 class="heading" style="background-image: none;"><a>Poll</a></h2>
                            <div class="columns-section">
                                <div class="columns-row">
                                    <poll :poll="poll"></poll>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="full-width  web-view">-->
<!--                        <div class="columns-box ">-->
<!--                            <h2 class="heading"><a :href="$store.state.hrefPrefix + '/columns'">{{ $t("columns") }}</a>-->
<!--                            </h2>-->
<!--                            <div class="columns-section">-->
<!--                                <column-article v-for="author in columnArticles"-->
<!--                                                :author="author"></column-article>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="full-width" :class="{'order-last': podcasts == null}">
                        <most-popular :articles="mostPopularArticle" :ad-Banner="mostPopularAd" :ad-banners="adBanners"></most-popular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "@/parts/home/Banner.vue";
import Slider from "@/parts/home/slider/Slider.vue";
import HomeFeaturedArticle from "@/parts/home/HomeFeatureArticle.vue";
import MiddleArticle from "@/parts/home/MiddleArticle.vue";
import ColumnArticle from "@/parts/Columns/ColumnArticle.vue";
import ListSecondArticle from "@/parts/home/ListSecondArticle.vue";
import MostPopularArticle from "@/parts/home/MostPopularArticle.vue";
import SliderArticle from "@/parts/home/slider/SliderArticle.vue";
import HomeTab from "@/parts/home/HomeTab.vue";
import SlideBarCategories from "@/parts/home/HomeTab.vue";
import MostPopular from "@/parts/home/MostPopular.vue";
import Poll from "@/parts/Poll.vue";
import AdBanner from "@/parts/adBanner.vue";

let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
}

export default {
    name: "HomePage",
    components: {
        AdBanner,
        Poll,
        MostPopular,
        SlideBarCategories,
        SliderArticle,
        MostPopularArticle,
        ListSecondArticle, ColumnArticle, MiddleArticle, HomeFeaturedArticle, Slider, Banner,
        HomeTab
    },
    props: {
        topBarCategories: {
            type: Array,
            default: []
        },

        sliderArticles: {
            type: Array,
            default: []
        },
        podcasts: {
            default: []
        },

        featuredTopArticles: {
            type: Object,
            default: []
        },
        secondListCategories: {
            type: Array,
            default: []

        },

        columnArticles: {
            type: Object,
            default: []
        },


        middleArticles: {
            type: Object,
            default: []
        },

        mostPopularArticle: {
            type: Object,
            default: []
        },
        adBanners:{
            type: Object,
            default: []
        },

        poll: {
            default: null
        },


    },

    data() {
        return {
            errors: errors,
            successes: successes,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        submitSubscribe(response) {
            console.log(response)
            this.$refs.subscribeFormButton.click()
        },
        adjustIframeHeight() {
            // Get video-container width
            const videoContainer = document.getElementsByClassName('video-container')[0];
            // Get the height bey aspect ratio 16/9
            const height = videoContainer.offsetWidth * 9 / 16;
            // Set the height
            videoContainer.style.height = height + 'px';
            // Set the iframe height
            document.getElementById('video-iframe').style.height = height + 'px';
        }
    },
    mounted() {
        window.submitSubscribe = this.submitSubscribe;
        this.adjustIframeHeight();
        window.addEventListener('resize', (event) => {
            this.adjustIframeHeight();
        }, true);
    },
    computed: {
        adPartOne(){
            return this.adBanners.find(banner => banner.placement === 'home_part_1')
        },
        adPartTwo(){
            return this.adBanners.find(banner => banner.placement === 'home_part_2')
        },
        mostPopularAd(){
            return this.adBanners.find(banner => banner.placement === 'most_popular')
        },
    }
}
</script>

<style scoped>

.flex-col {
    display: flex;
    flex-direction: column;
}

.full-width {
    width: 100%;
}

#content-container {
    row-gap: 40px;
    grid-template-rows: auto 1fr;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
}

#podcast-content {
    min-height: 0;
    grid-row: 1 / span 1;
    grid-column: 1 / span 8;
}

#side-content {
    grid-row: 1 / span 2;
    grid-column: 9 / span 4;
}

#main-content {
    grid-row: 2 / span 1;
    grid-column: 1 / span 8;
}

@media (min-width: 480px) {
    #content-container {
        column-gap: 40px;
    }
}
@media (max-width: 960px) {
    #content-container {
        grid-template-rows: auto auto auto;
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
    }

    #podcast-content {
        min-height: 0;
        grid-row: 1 / span 1;
        grid-column: 1 / span 12;
    }

    #side-content {
        grid-row: 2 / span 1;
        grid-column: 1 / span 12;
    }

    #main-content {
        grid-row: 3 / span 1;
        grid-column: 1 / span 12;
    }
}

.web-view-poll {
    display: block;
}

@media (max-width: 960px) {
    .web-view-poll {
        display: block !important;
    }
}

@media (max-width: 767px) {
    .web-view-poll {
        display: block !important;
    }
}

.video-container {
    width: 100%;
}
.video-container iframe {
    width: 100%;
}

</style>
